<template>
  <div
    class="option_selection"
    style="display: block"
    v-if="
      details.selectableAttributes != null &&
      (details.selectableAttributes.SIZE || details.selectableAttributes.COLOR)
    "
  >
    <div v-if="details.selectableAttributes.COLOR" class="prod_color">
      <h6 class="prdt_sub_hdng">{{ $t("selectColor") }}</h6>
      <ul
        class="color_list"
        v-if="
          details.selectableAttributes.COLOR.length === 1 &&
          !this.dataColor.selectableAttributes.SIZE
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio2"
            id="0"
            :value="details.selectableAttributes.COLOR[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">
            <span class="colr_txt">{{
              details.selectableAttributes.COLOR[0].itemAttributeValue
            }}</span>
          </label>
        </li>
      </ul>
      <ul
        class="color_list"
        v-else-if="
          details.selectableAttributes.COLOR.length === 1 &&
          this.dataColor.selectableAttributes.SIZE.length === 1
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio2"
            id="0"
            :value="details.selectableAttributes.COLOR[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">
            <span class="colr_txt">{{
              details.selectableAttributes.COLOR[0].itemAttributeValue
            }}</span>
          </label>
        </li>
      </ul>
      <ul
        class="color_list"
        v-else-if="
          details.selectableAttributes.COLOR.length === 1 &&
          this.dataColor.selectableAttributes.SIZE.length > 1
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio2"
            id="0"
            :value="details.selectableAttributes.COLOR[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">
            <span class="colr_txt">{{
              details.selectableAttributes.COLOR[0].itemAttributeValue
            }}</span>
          </label>
        </li>
      </ul>
      <ul class="color_list" v-else>
        <li
          v-bind:class="{ 'prod_act ': colors == index, ' ': colors != index }"
          v-for="(clr, index) in filterColor"
          :key="index"
        >
          <!-- {{clr.color}} -->
          <input
            type="radio"
            name="radio2"
            :id="'clr' + index"
            :value="index"
            class="cstm_radio"
            v-model="colors"
            @click="selectColor(clr.color.itemId, clr.color.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'clr' + index">
            <span class="colr_txt">{{ index }}</span>
          </label>
        </li>
      </ul>
    </div>
    <div v-if="details.selectableAttributes.SIZE" class="prod_color">
      <h6 class="prdt_sub_hdng">{{ $t("selectSize") }}</h6>
      <ul
        v-if="
          details.selectableAttributes.SIZE.length === 1 &&
          !this.dataColor.selectableAttributes.COLOR
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio3"
            id="0"
            :value="details.selectableAttributes.SIZE[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">{{
            details.selectableAttributes.SIZE[0].itemAttributeValue
          }}</label>
        </li>
      </ul>
      <ul
        v-else-if="
          details.selectableAttributes.SIZE.length === 1 &&
          this.dataColor.selectableAttributes.COLOR.length === 1
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio3"
            id="0"
            :value="details.selectableAttributes.SIZE[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">{{
            details.selectableAttributes.SIZE[0].itemAttributeValue
          }}</label>
        </li>
      </ul>
      <ul
        v-else-if="
          details.selectableAttributes.SIZE.length === 1 &&
          this.dataColor.selectableAttributes.COLOR.length > 1
        "
      >
        <li class="prod_act">
          <input
            type="radio"
            name="radio3"
            id="0"
            :value="details.selectableAttributes.SIZE[0].itemAttributeValue"
            class="cstm_radio"
          />
          <label class="cstm_label">{{
            details.selectableAttributes.SIZE[0].itemAttributeValue
          }}</label>
        </li>
      </ul>
      <ul
        v-else-if="
          !this.dataColor.selectableAttributes.COLOR &&
          dataColor.selectableAttributes.SIZE.length > 1
        "
      >
        <li
          v-bind:class="{ prod_act: prodSize == index }"
          v-for="(s, index) in filterColor"
          :key="index"
        >
          <input
            type="radio"
            name="radio3"
            :id="'s' + index"
            :value="index"
            class="cstm_radio"
            v-model="prodSize"
            @click="selectSize(s.color.itemId, s.color.itemAttributeValue)"
          />
          <label class="cstm_label" :for="'s' + index">{{
            s.color.itemAttributeValue
          }}</label>
        </li>
      </ul>
      <div v-else>
        <ul
          v-if="
            !noOneSelected &&
            details.selectableAttributes.SIZE.length > 1 &&
            this.dataColor.selectableAttributes.COLOR.length > 1
          "
        >
          <li
            v-for="(s, index) in dataColor.selectableAttributes.SIZE"
            :key="index"
          >
            <input
              type="radio"
              name="radio3"
              :id="'s' + index"
              :value="index"
              class="cstm_radio"
              v-model="prodSize"
              @click="selectColorFirst()"
            />
            <label class="cstm_label" :for="'s' + index">{{
              s.itemAttributeValue
            }}</label>
          </li>
        </ul>
        <ul v-else>
          <li
            v-bind:class="{
              prod_act: prodSize == index,
              deactive: !s.hasOwnProperty('active'),
            }"
            v-for="(s, index) in filterColor[selectedColor].size"
            :key="index"
          >
            <input
              type="radio"
              name="radio3"
              :id="'s' + index"
              :value="index"
              class="cstm_radio"
              v-model="prodSize"
              @click="selectSize(s.itemId, s.itemAttributeValue)"
            />
            <label class="cstm_label" :for="'s' + index">{{
              s.itemAttributeValue
            }}</label>
          </li>
        </ul>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../../assets/images/loader.gif" alt="loader" />
    </div>
    <div id="cart-snackbar" :class="{ show: nonSelectedError }">
      <div class="flx" style="justify-content: center">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AllColorArray from "../../../utils/AllColorArray";
import constant from "../../../utils/constant";
import ApiCaller from "../../../utils/apicaller";
export default {
  name: "Color",
  props: {
    dataColor: {
      require: true,
      type: Object,
    },
  },
  data() {
    return {
      details: {},
      colors: null,
      loading: false,
      prodSize: null,
      selectedItemAttributeIds: [],
      colorType: "",
      sizeID: "",
      styleColorArray: {},
      styleObject: AllColorArray,
      colorName: "",
      filterColor: {},
      selectedColor: "",
      noOneSelected: false,
      nonSelectedError: false,
      errorMessage: "",
    };
  },
  watch: {
    dataColor() {
      this.details = this.dataColor;
    },
  },
  computed: {},
  created() {
    this.filterColorAndSize();
    this.updatedFilterSizeList();
  },
  methods: {
    updatedFilterSizeList() {
      for (let i in this.filterColor) {
        for (
          let j = 0;
          j < this.dataColor.selectableAttributes.SIZE.length;
          ++j
        ) {
          const userExists = this.filterColor[i].size.some(
            (user) =>
              user.itemAttributeValue ===
              this.dataColor.selectableAttributes.SIZE[j].itemAttributeValue
          );
          if (!userExists) {
            this.filterColor[i].size.push(
              this.dataColor.selectableAttributes.SIZE[j]
            );
          }
        }
      }
      for (let i in this.filterColor) {
        this.filterColor[i].size.sort((a, b) =>
          Number(a.itemAttributeValue) > Number(b.itemAttributeValue)
            ? 1
            : Number(b.itemAttributeValue) > Number(a.itemAttributeValue)
            ? -1
            : 0
        );
      }
    },
    filterColorAndSize() {
      let obj = {};
      let colorArray = this.dataColor.allSelectableAttributes.COLOR;
      let sizeArray = this.dataColor.allSelectableAttributes.SIZE;
      if (sizeArray === undefined && colorArray !== undefined) {
        for (let i = 0; i < colorArray.length; ++i) {
          obj[colorArray[i].itemAttributeValue] = {
            color: colorArray[i],
            size: [],
          };
        }
      } else if (sizeArray !== undefined && colorArray === undefined) {
        for (let i = 0; i < sizeArray.length; ++i) {
          obj[sizeArray[i].itemAttributeValue] = {
            color: sizeArray[i],
            size: [],
          };
        }
      } else if (sizeArray !== undefined && colorArray !== undefined) {
        for (let i = 0; i < colorArray.length; ++i) {
          for (let j = 0; j < sizeArray.length; ++j) {
            if (sizeArray[j].itemId === colorArray[i].itemId) {
              if (!obj.hasOwnProperty(colorArray[i].itemAttributeValue))
                obj[colorArray[i].itemAttributeValue] = {
                  color: colorArray[i],
                  size: [],
                };
              let temp = sizeArray[j];
              temp.active = true;
              obj[colorArray[i].itemAttributeValue].size.push(temp);
              if (colorArray.length)
                this.selectedColor = colorArray[0].itemAttributeValue;
            }
          }
        }
      }
      this.filterColor = Object.assign({}, this.filterColor, obj);
    },

    getColor(val) {
      const index = Object.keys(this.styleObject).indexOf(val.toLowerCase());
      return Object.values(this.styleObject)[index];
    },
    getBorderColor(val, indexValue) {
      const index = Object.keys(this.styleObject).indexOf(val.toLowerCase());
      if (this.colors == indexValue) {
        return Object.values(this.styleObject)[index];
      } else if (this.colors != indexValue) {
        return "white";
      }
    },

    selectColor(itemId, Color) {
      this.loading = true;
      if (this.prodSize != null) {
        this.prodSize = null;
        this.$emit("ProductSize", null);
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "get-product-detail-by-item/" + itemId,
        "get"
      )
        .then((data) => {
          this.loading = false;
          this.selectedColor = Color;
          this.noOneSelected = true;
          this.$emit("ProductColor", Color);
          this.$emit(
            "PRODUCTDETAILAFFTERSELECTION",
            data.data.productListingDTO
          );
        })
        .catch((err) => {
          this.loading = false;
          this.colors = null;
          this.nonSelectedError = !this.nonSelectedError;
          this.errorMessage = err.response.data.message;
          setTimeout(() => {
            this.nonSelectedError = !this.nonSelectedError;
          }, 3000);
          console.log(err);
        });
    },
    selectSize(selectSize) {
      console.log("select size", selectSize);
      this.loading = true;
      console.log(this.prodSize);
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "get-product-detail-by-item/" + selectSize,
        "get"
      )
        .then((data) => {
          this.$emit("ProductSize", selectSize);

          this.loading = false;
          this.$emit(
            "PRODUCTDETAILAFFTERSELECTION",
            data.data.productListingDTO
          );
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.nonSelectedError = !this.nonSelectedError;
          this.errorMessage = err.response.data.message;
          setTimeout(() => {
            this.nonSelectedError = !this.nonSelectedError;
          }, 3000);
          console.log(err);
          this.prodSize = null;
        });
    },
    selectColorFirst() {
      this.nonSelectedError = !this.nonSelectedError;
      this.errorMessage = this.$t("pleaseSelectColor");
      setTimeout(() => {
        this.nonSelectedError = !this.nonSelectedError;
      }, 3000);
    },
  },
  mounted() {
    this.details = this.dataColor;
  },
};
</script>
